import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify"; // ✅ Usar react-hot-toast

export const useEmailTemplate = () => {
   const queryClient = useQueryClient();
   const token = localStorage.getItem("token");
   const baseUrl = process.env.REACT_APP_URL_DIR + "emailtemplate";
   const urlMail = process.env.REACT_APP_URL_DIR + "mailer";
   const GetEmailTemplates = () => {
      const { data } = useQuery({
         queryKey: ["EmailTemplates"],
         queryFn: () =>
            fetch(baseUrl, {
               headers: {
                  Authorization: `Bearer ${token}`,
               },
            }).then((res) => res.json()),
      });
      if (data?.message === "Token inválido") {
         toast.error("Token inválido.Por favor vuelva a logonearse");
         return null;
      }
      return data;
   };
   const crearEmailTemplate = useMutation({
      mutationFn: async (EmailTemplateData) => {
         const isUpdate = EmailTemplateData.id > 0;
         const method = isUpdate ? "PUT" : "POST";
         const url = isUpdate
            ? `${baseUrl}/${EmailTemplateData.id}`
            : `${baseUrl}`;
         const response = await fetch(url, {
            method,
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
            body: JSON.stringify(EmailTemplateData),
         });
         return response.json();
      },
      onSuccess: () => {
         toast.success("EmailTemplate actualizado");
      },
      onFailure: () => {
         toast.error("Error creando EmailTemplate");
      },
   });

   const deleteEmailTemplates = useMutation({
      mutationFn: async (id) => {
         const response = await fetch(`${baseUrl}/${id}`, {
            method: "DELETE",
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         });
         return response.json();
      },
      onSuccess: (resp) => {
         if (resp?.message) {
            toast.warn(resp.message);
         } else {
            toast.success("EmailTemplate eliminado");
         }

         queryClient.invalidateQueries(["EmailTemplate"]);
      },
      onError: () => {
         toast.error("Error eliminando EmailTemplate");
      },
   });

   const sendTestEmail = useMutation({
      mutationFn: async (emailData) => {
         const response = await fetch(urlMail, {
            method: "POST",
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
            body: JSON.stringify(emailData),
         });
         return response.json();
      },
      onSuccess: (resp) => {
         if (resp?.message) {
            toast.success(resp.message);
         } else {
            toast.success("Email de prueba enviado correctamente");
         }
      },
      onError: (error) => {
         toast.error("Error enviando email de prueba");
         console.error(error);
      },
   });

   return { GetEmailTemplates, deleteEmailTemplates, crearEmailTemplate, sendTestEmail };
};
